<template>
  <div>
    <h5 class="ui header">{{ $t('PREFERENCE_LP_HEADER') }}</h5>
    <p>{{ $t('PREFERENCE_LP_BODY') }}</p>
    <div class="ui equal width grid">
      <div class="column" v-for="colIdx in [0, 1, 2]" :key="colIdx">
        <div class="ui segments">
          <div class="ui segment">
            <dropdown-select
              :labelText="$tc('TYPE', 1)"
              :items="options"
              :initialSelection="selectedOptions[colIdx]"
              @selected="selectDisplay(colIdx, $event)"
              :multipleInitialSelections="true"
              :emitInitialSelection="false"
              :optional="true"
            />
          </div>
          <div class="ui segment" v-if="selectedOptions[colIdx]">
            <component
              :is="selectedOptions[colIdx].optionsComponent"
              v-bind="configuredOptions[colIdx]"
              @update="updateConfiguredOptions(colIdx, $event)"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @flow
import Vue from 'vue'

import LastEditsOptions from './LastEditsOptions'
import FlowsLandingPageOptions from '../Applications/Flows/FlowsLandingPageOptions'
import { DropdownSelect } from 'ui'

export default {
  name: 'customization',

  components: { DropdownSelect },

  props: ['value'],

  data() {
    return {
      options: [
        {
          id: 'last-edits',
          name: this.$i18n.t('LAST_EDITS'),
          componentName: 'last-edits', // NOTE: must be globally registered
          optionsComponent: LastEditsOptions
        },
        {
          id: 'saved-search',
          name: this.$i18n.tc('SAVED_SEARCH'),
          componentName: 'flows', // NOTE: must be globally registered
          optionsComponent: FlowsLandingPageOptions
        }
      ],
      selectedOptions: [null, null, null],
      configuredOptions: [null, null, null]
    }
  },

  methods: {
    selectDisplay(colIdx, option) {
      Vue.set(this.selectedOptions, colIdx, option)
      Vue.set(this.configuredOptions, colIdx, {})
      this.emitValue()
    },
    updateConfiguredOptions(colIdx, value) {
      Vue.set(this.configuredOptions, colIdx, value)
      this.emitValue()
    },
    emitValue() {
      this.$emit(
        'update',
        _.map(this.configuredOptions, (opt, idx) => ({
          id: this.selectedOptions[idx]?.id,
          componentName: this.selectedOptions[idx]?.componentName,
          params: opt
        }))
      )
    }
  },

  mounted() {
    this.selectedOptions = _.map(this.value || [null, null, null], v =>
      _.find(this.options, opt => opt.id === v?.id)
    )

    this.configuredOptions = _.map(this.value || [null, null, null], v => v?.params)
  }
}
</script>
